import React from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { LABEL_POSITION_LEFT, DATE_FORMAT } from './constant';
import RichTextTinymceEditor from './richtext-tinymce-editor';
import ReactStars from 'react-rating-stars-component';
import CountryCode from './CountryCode';
import _ from 'lodash';

export const renderFieldText = field => {
  var { meta, labelposition, label, placeholder, type } = field;
  var divClassName = `form-group row ${
    meta.touched && meta.error ? 'has-danger' : ''
  }`;
  var labelClasses = 'control-label-top col-sm-12';
  var inputClasses = 'col-sm-12 col-sm-offset-0';

  if (labelposition === LABEL_POSITION_LEFT) {
    labelClasses = 'control-label col-xs-12 col-sm-12 col-md-3';
    inputClasses = 'col-xs-12 col-sm-12 col-md-9 col-sm-offset-0';
  }

  return (
    <div className={divClassName}>
      {label !== '' ? (
        <label className={labelClasses}>
          {label}
          <span className="label-mandatory">
            {field.mandatory === 'true' ? '*' : ''}
          </span>
        </label>
      ) : null}

      <div className={inputClasses} /* style={{ position: 'relative' }} */>
        {field?.disabled ? (
          <span
            className="form-control input-field"
            style={{
              border: 'var(--input-border)',
              backgroundColor: 'var(--offwhite-bg)'
            }}
          >
            {field?.input?.value}
          </span>
        ) : type === 'password' ? (
          <input
            className="form-control input-field"
            type={type}
            placeholder={placeholder}
            {...field.input}
            maxLength={field.maxlength ? field.maxlength : ''}
            autoComplete="new-password"
          />
        ) : (
          <input
            className="form-control input-field"
            type={type}
            placeholder={placeholder}
            {...field.input}
            maxLength={field.maxlength ? field.maxlength : ''}
          />
        )}
        <div className="text-help">{meta.touched ? meta.error : ''}</div>
        {field.maxlength ? (
          <span className="char-left">
            {field.input.value.length}
            {' / '}
            {field.maxlength}
          </span>
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

export const renderHiddenFieldText = field => {
  var { meta } = field;
  var divClassName = `${meta.touched && meta.error ? 'has-danger' : ''}`;

  return (
    <div className={divClassName}>
      <div style={{ display: 'none' }}>
        <input className="form-control" type={field.type} {...field.input} />
      </div>
      <div className="text-help">{meta.touched ? meta.error : ''}</div>
    </div>
  );
};

export const renderFieldTextarea = field => {
  var { label, labelposition, meta } = field;
  var divClassName = `form-group row ${
    meta.touched && meta.error ? 'has-danger' : ''
  }`;
  var labelClasses = 'control-label-top col-sm-12';
  var inputClasses = 'col-sm-12 col-sm-offset-0';

  if (labelposition === LABEL_POSITION_LEFT) {
    labelClasses = 'control-label col-xs-12 col-sm-12 col-md-3';
    inputClasses = 'col-xs-12 col-sm-12 col-md-9 col-sm-offset-0';
  }

  return (
    <div className={divClassName}>
      {label !== '' ? (
        <label className={labelClasses}>
          {label}
          <span className="label-mandatory">
            {field.mandatory === 'true' ? '*' : ''}
          </span>
        </label>
      ) : null}

      <div className={inputClasses} /* style={{ position: 'relative' }} */>
        {field?.disabled ? (
          <span
            className="form-control textarea-field scrollbar-hide-no-maxheight"
            style={{
              border: 'var(--input-border)',
              backgroundColor: 'var(--offwhite-bg)'
            }}
          >
            {field?.input?.value}
          </span>
        ) : (
          <textarea
            className="form-control textarea-field"
            placeholder={field.placeholder}
            {...field.input}
            maxLength={field.maxlength ? field.maxlength : ''}
          ></textarea>
        )}
        <div className="text-help">{meta.touched ? meta.error : ''}</div>
      </div>
      {field.maxlength ? (
        <span className="char-left">
          {field.input.value.length}
          {' / '}
          {field.maxlength}
        </span>
      ) : (
        ''
      )}
    </div>
  );
};

export const renderSelect = field => {
  var { label, labelposition, meta } = field;
  var divClassName = `form-group row ${
    meta.touched && meta.error ? 'has-danger' : ''
  }`;
  var labelClasses = 'control-label-top col-sm-12';
  var inputClasses = 'col-sm-12 col-sm-offset-0';

  if (labelposition === LABEL_POSITION_LEFT) {
    labelClasses = 'control-label col-xs-12 col-sm-12 col-md-3';
    inputClasses = 'col-xs-12 col-sm-12 col-md-9 col-sm-offset-0';
  }

  let selectedValue = !_.isEmpty(field?.opts)
    ? _.find(field?.opts, opt => opt.value == field?.input?.value)
    : '';
  if (!_.isEmpty(selectedValue)) selectedValue = selectedValue.text;

  return (
    <div className={divClassName}>
      {label !== '' ? (
        <label className={labelClasses}>
          {label}
          <span className="label-mandatory">
            {field.mandatory === 'true' ? '*' : ''}
          </span>
        </label>
      ) : null}

      <div className={inputClasses}>
        {field?.disabled ? (
          <span
            className="form-control input-field"
            style={{
              border: 'var(--input-border)',
              backgroundColor: 'var(--offwhite-bg)'
            }}
          >
            {selectedValue}
          </span>
        ) : (
          <select
            className="form-control input-field"
            {...field.input}
            disabled={field?.disabled ?? false}
          >
            <option value="" key={field.label}>
              {field.placeholder}
            </option>
            {!_.isEmpty(field) && !_.isEmpty(field.opts)
              ? field.opts.map((object, index) => {
                  return (
                    <option
                      key={`${object.value}-${index}`}
                      value={object.value}
                    >
                      {object.text}
                    </option>
                  );
                })
              : _.map(CountryCode, (country, index) => {
                  return (
                    <option
                      key={`${country.country_name}-${index}`}
                      value={country.country_name}
                    >
                      {country.country_name}
                    </option>
                  );
                })}
          </select>
        )}
        <div className="text-help label-text-help">
          {meta.touched ? meta.error : ''}
        </div>
      </div>
    </div>
  );
};

// export const renderCheckbox = field => {
//   let { label, opts, input, labelposition, meta } = field;
//   var divClassName = `form-group row ${
//     meta.touched && meta.error ? 'has-danger' : ''
//   }`;
//   var labelClasses = 'control-label-top col-sm-12';
//   var inputClasses = 'col-sm-12 col-sm-offset-0';

//   if (labelposition === LABEL_POSITION_LEFT) {
//     labelClasses = 'control-label col-xs-12 col-sm-12 col-md-3';
//     inputClasses = 'col-xs-12 col-sm-12 col-md-9 col-sm-offset-0';
//   }

//   return (
//     <div className={divClassName}>
//       {label !== '' ? (
//         <label className={labelClasses}>
//           {label}
//           <span className="label-mandatory">
//             {field.mandatory === 'true' ? '*' : ''}
//           </span>
//         </label>
//       ) : null}

//       <div className={inputClasses}>
//         {!_.isEmpty(opts) &&
//           opts.map((option, index) => {
//             const fieldChecked = input.value.indexOf(option.value) !== -1;

//             return (
//               <div key={index}>
//                 <label
//                   className={`custom-container-checkbox${
//                     field?.disabled ? ' disabled-input' : ''
//                   }${
//                     !fieldChecked ? '-notchecked ' : ' '
//                   }custom-text1-normal mb-0`}
//                 >
//                   {option.text}

//                   {!field?.disabled ? (
//                     <input
//                       type="checkbox"
//                       name={`${input.name}[${index}]`}
//                       value={option.value}
//                       checked={fieldChecked}
//                       onChange={event => {
//                         const newValue = [...input.value];
//                         if (event.target.checked) {
//                           newValue.push(option.value);
//                         } else {
//                           newValue.splice(newValue.indexOf(option.value), 1);
//                         }
//                         return input.onChange(newValue);
//                       }}
//                       onBlur={() => input.onBlur(input.value)}
//                       disabled={field?.disabled ?? false}
//                     />
//                   ) : (
//                     ''
//                   )}

//                   <span className="checkmark" />
//                 </label>
//               </div>
//             );
//           })}
//         <div className="text-help">{meta.touched ? meta.error : ''}</div>
//       </div>
//     </div>
//   );
// };

export const renderCheckbox = field => {
  const { label, opts, input, labelposition, meta } = field;

  var divClassName = `form-group row mx-0${
    meta.touched && meta.error ? ' has-danger' : ''
  }`;
  var labelClasses = 'control-label-top col-sm-12 p-0';
  var inputClasses = 'col-sm-12 col-sm-offset-0 px-0';

  if (labelposition === LABEL_POSITION_LEFT) {
    labelClasses = 'control-label col-xs-12 col-sm-12 col-md-3';
    inputClasses = 'col-xs-12 col-sm-12 col-md-9 col-sm-offset-0';
  }

  return (
    <div className={divClassName}>
      {label !== '' ? (
        <label className={labelClasses}>
          {label}
          <span className="label-mandatory">
            {field.mandatory === 'true' ? '*' : ''}
          </span>
        </label>
      ) : null}

      <div className={inputClasses}>
        {!_.isEmpty(opts) &&
          opts.map((option, index) => {
            const fieldChecked = input.value.indexOf(option.value) !== -1;

            return (
              <div key={index}>
                <label
                  className={`custom-container-checkbox${
                    field?.disabled
                      ? ` disabled-input${!fieldChecked ? '-notchecked' : ''} `
                      : ' '
                  }custom-text1-normal mb-0`}
                >
                  {option.text}

                  {!field?.disabled ? (
                    <input
                      type="checkbox"
                      name={`${input.name}[${index}]`}
                      value={option.value}
                      checked={input.value.indexOf(option.value) !== -1}
                      onChange={event => {
                        const newValue = [...input.value];
                        if (event.target.checked) {
                          newValue.push(option.value);
                        } else {
                          newValue.splice(newValue.indexOf(option.value), 1);
                        }
                        return input.onChange(newValue);
                      }}
                      onBlur={() => input.onBlur(input.value)}
                    />
                  ) : (
                    ''
                  )}

                  <span className="checkmark" />
                </label>
              </div>
            );
          })}
        <div className="text-help">{meta.touched ? meta.error : ''}</div>
      </div>
    </div>
  );
};

export const renderFieldRadio = field => {
  return (
    <div>
      <label
        className={`custom-container-radio${
          field?.disabled
            ? ` disabled-input${!field?.fieldChecked ? '-notchecked' : ''} `
            : ' '
        }custom-text1-normal mb-0`}
      >
        {field.label}

        {!field?.disabled ? (
          <input
            type={field.type}
            {...field.input}
            disabled={field?.disabled ?? false}
          />
        ) : (
          ''
        )}

        <span className="radiomark"></span>
      </label>

      <span className="text-help label-text-help">
        {field.lastOpt && field.meta.touched ? field.meta.error : ''}
      </span>
    </div>
  );
};

export const renderFieldCheckbox = field => {
  return (
    <div>
      {/* <label className={`custom-container-checkbox custom-text1-normal`}> */}
      <label
        className={`custom-container-checkbox${
          field?.disabled
            ? ` disabled-input${!field?.input?.checked ? '-notchecked' : ''} `
            : ' '
        }custom-text1-normal mb-0`}
      >
        {field.label}
        <input
          type={field.type}
          {...field.input}
          disabled={field?.disabled ?? false}
        />
        <span className="checkmark" />
      </label>
    </div>
  );
};

export const renderDatePickerWithLabel = field => {
  var { input, selected, disabled, label, labelposition, meta } = field;
  // var value = input.value ? moment(input.value) : null;
  // var selectedValue = value ? value : selected;

  var value = input.value
    ? moment(input.value).format(DATE_FORMAT)
    : selected
    ? moment(selected).format(DATE_FORMAT)
    : null;
  var selectedValue = value
    ? moment(value)
    : selected
    ? selected
    : moment(moment().format(DATE_FORMAT));

  // var selectedValue = value
  //   ? parse(value, DATE_FORMAT, new Date())
  //   : selected
  //   ? selected
  //   : new Date();

  // var value = input.value ? moment(input.value).format(DATE_FORMAT) : null;
  // var selectedValue = value ? moment(input.value) : selected;
  var divClassName = `form-group row ${
    meta.touched && meta.error ? 'has-danger' : ''
  }`;
  var labelClasses = 'control-label-top col-sm-12';
  var inputClasses = 'col-sm-12 col-sm-offset-0';

  if (labelposition === LABEL_POSITION_LEFT) {
    labelClasses = 'control-label col-xs-12 col-sm-12 col-md-3';
    inputClasses = 'col-xs-12 col-sm-12 col-md-9 col-sm-offset-0';
  }

  return (
    <div className={divClassName}>
      {label !== '' ? (
        <label className={labelClasses}>
          {label}
          <span className="label-mandatory">
            {field.mandatory === 'true' ? '*' : ''}
          </span>
        </label>
      ) : null}

      <div className={inputClasses}>
        <DatePicker
          className="form-control"
          name={input.name}
          {...input}
          value={value}
          // selected={selectedValue}
          dateFormat={DATE_FORMAT}
          disabled={disabled ?? field?.disabled ?? false}
        />
        <div className="text-help label-text-help">
          {meta.touched ? meta.error : ''}
        </div>
      </div>
    </div>
  );
};

export const renderDateTimePickerWithLabel = field => {
  const {
    input,
    disabled,
    label,
    labelposition,
    meta,
    mandatory,
    selected,
    placeholder
  } = field;
  var DATE_TIME_FORMAT = 'yyyy-MM-dd HH:mm';
  var selectedValue = input?.value ? input.value : selected ? selected : null;
  if (typeof selectedValue == 'string') {
    selectedValue = new Date(selectedValue);
  }

  var divClassName = `form-group row ${
    meta.touched && meta.error ? 'has-danger' : ''
  }`;
  var labelClasses = 'control-label-top col-sm-12';
  var inputClasses = 'col-sm-12 col-sm-offset-0';

  if (labelposition === LABEL_POSITION_LEFT) {
    labelClasses = 'control-label col-xs-12 col-sm-12 col-md-3';
    inputClasses = 'col-xs-12 col-sm-12 col-md-9 col-sm-offset-0';
  }

  return (
    <div className={divClassName}>
      {label !== '' ? (
        <label className={labelClasses}>
          {label}
          <span className="label-mandatory">
            {mandatory && mandatory === 'true' ? '*' : ''}
          </span>
        </label>
      ) : null}

      <div className={inputClasses}>
        <DatePicker
          className="form-control"
          isClearable
          placeholderText={placeholder ? placeholder : ''}
          name={input.name}
          {...input}
          selected={selectedValue}
          showTimeSelect
          timeIntervals={10}
          timeFormat={`HH:mm`}
          dateFormat={DATE_TIME_FORMAT}
          disabled={disabled ?? field?.disabled ?? false}
          onChange={input.onChange}
        />
        <div className="text-help label-text-help">
          {meta.touched ? meta.error : ''}
        </div>
      </div>
    </div>
  );
};

export const renderHtmlInputDatePicker = field => {
  var { meta, labelposition, label, placeholder, type } = field;
  var divClassName = `form-group row ${
    meta.touched && meta.error ? 'has-danger' : ''
  }`;
  var labelClasses = 'control-label-top col-sm-12';
  var inputClasses = 'col-sm-12 col-sm-offset-0';

  if (labelposition === LABEL_POSITION_LEFT) {
    labelClasses = 'control-label col-xs-12 col-sm-12 col-md-3';
    inputClasses = 'col-xs-12 col-sm-12 col-md-9 col-sm-offset-0';
  }

  return (
    <div className={divClassName}>
      {label !== '' ? (
        <label className={labelClasses}>
          {label}
          <span className="label-mandatory">
            {field.mandatory === 'true' ? '*' : ''}
          </span>
        </label>
      ) : null}

      <div className={inputClasses}>
        <input
          className="form-control input-field"
          type="date"
          placeholder={placeholder}
          {...field.input}
          disabled={field?.disabled ?? false}
        />

        <div className="text-help">{meta.touched ? meta.error : ''}</div>
      </div>
    </div>
  );
};

export const renderHtmlInputTimePicker = field => {
  var { meta, labelposition, label, placeholder, type } = field;
  var divClassName = `form-group row ${
    meta.touched && meta.error ? 'has-danger' : ''
  }`;
  var labelClasses = 'control-label-top col-sm-12';
  var inputClasses = 'col-sm-12 col-sm-offset-0';

  if (labelposition === LABEL_POSITION_LEFT) {
    labelClasses = 'control-label col-xs-12 col-sm-12 col-md-3';
    inputClasses = 'col-xs-12 col-sm-12 col-md-9 col-sm-offset-0';
  }

  return (
    <div className={divClassName}>
      {label !== '' ? (
        <label className={labelClasses}>
          {label}
          <span className="label-mandatory">
            {field.mandatory === 'true' ? '*' : ''}
          </span>
        </label>
      ) : null}

      <div className={inputClasses}>
        <input
          className="form-control input-field"
          type="time"
          placeholder={placeholder}
          {...field.input}
          disabled={field?.disabled ?? false}
        />

        <div className="text-help">{meta.touched ? meta.error : ''}</div>
      </div>
    </div>
  );
};

export const renderRichTextareaWithLabelTinymce = field => {
  var { labelposition, label, meta } = field;
  var divClassName = `form-group row ${
    meta.touched && meta.error ? 'has-danger' : ''
  }`;
  var labelClasses = 'control-label-top col-sm-12';
  var inputClasses = 'col-sm-12 col-sm-offset-0';

  if (labelposition === LABEL_POSITION_LEFT) {
    labelClasses = 'control-label col-xs-12 col-sm-12 col-md-3';
    inputClasses = 'col-xs-12 col-sm-12 col-md-9 col-sm-offset-0';
  }

  return (
    <div className={divClassName}>
      {label !== '' ? (
        <label className={labelClasses}>
          {label}
          <span className="label-mandatory">
            {field.mandatory === 'true' ? '*' : ''}
          </span>
        </label>
      ) : null}

      <div className={inputClasses}>
        <RichTextTinymceEditor type={field.type} {...field} />
        <div className="text-help label-text-help">
          {meta.error ? meta.error : ''}
        </div>
      </div>
    </div>
  );
};

export const validateEmail = email => {
  // var re = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;
  var re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/;
  return re.test(email);
};

export const validatePhone = phone => {
  let re = /^[\+]?[(]?[0-9]{2,5}[)]?[-\s\.]?[0-9]{2,5}[-\s\.]?[0-9]{2,5}[-\s\.]?[0-9]{4,6}$/im;
  // let re = /^\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\W*\d\W*\d\W*\d\W*\d\W*\d\W*\d\W*\d\W*\d\W*(\d{1,2})$/
  return re.test(phone);
};

export const validateUrl = url => {
  // var re = /^(?:(http|https):\/\/)?(?:[\w-]+\.)+[a-z]{2,6}$/;
  var re = /^(?:(?:(?:https?|http):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/;
  return re.test(url);
};

/**
  http://example.com
  https://www.example.com
  example.com
  example.com/page
  http://subdomain.example.com
  http://subdomain.example.com/page
  https://example.co.uk
  www.example.com
  www.example.com/page
 */
export const validateSocialUrl = url => {
  var re = /^(?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(?:\/[^\s]*)?$/;
  return re.test(url);
};

export const validateOnlyNums = value => {
  // return value.replace(/[^\d]/g, "");
  // let check = !isNaN(value);
  var re = /^\d+$/;
  var check = re.test(value);

  return check;
};

export const renderStarRating = field => {
  var { input, meta, labelposition, label, changeGenRating, color } = field;
  var divClassName = `form-group row ${
    meta.touched && meta.error ? 'has-danger' : ''
  }`;
  var labelClasses = 'control-label-top col-sm-12';
  var inputClasses = 'col-sm-12 col-sm-offset-0';

  if (labelposition === LABEL_POSITION_LEFT) {
    labelClasses = 'control-label col-xs-12 col-sm-12 col-md-3';
    inputClasses = 'col-xs-12 col-sm-12 col-md-9 col-sm-offset-0';
  }

  return (
    <div className={divClassName}>
      {label !== '' ? (
        <label className={labelClasses}>
          {label}
          <span className="label-mandatory">
            {field.mandatory === 'true' ? '*' : ''}
          </span>
        </label>
      ) : null}

      <div className={inputClasses}>
        <ReactStars
          size={25}
          count={5}
          color={color}
          activeColor={color}
          value={0}
          isHalf={true}
          emptyIcon={
            <i
              className="fa fa-star-o"
              aria-hidden="true"
              style={{ color: 'lightgray' }}
            />
          }
          halfIcon={
            <i className="fa-solid fa-star-half-stroke" aria-hidden="true" />
          }
          filledIcon={<i className="fa fa-star" />}
          onChange={newValue =>
            !field?.disabled && changeGenRating(newValue, input.name)
          }
        />
        <div className="text-help">{meta.touched ? meta.error : ''}</div>
      </div>
    </div>
  );
};
